const registerButton = document.getElementById('register-button');
const firstName = document.getElementById('RegisterForm-FirstName');
const lastName = document.getElementById('RegisterForm-LastName')
const registerEmail = document.getElementById('RegisterForm-email')
const registerPassword = document.getElementById('RegisterForm-password');
const registerConfirmPassword = document.getElementById('RegisterForm-confirm-password');
const registerForm = document.getElementById('create_customer')

const registerShowPassword = document.getElementById('r-show-password')
const registerHidePassword = document.getElementById('r-hide-password')
const registerPasswordContainer = document.getElementById('register-password-field-container')
const registerConfirmShowPassword = document.getElementById('rc-show-password')
const registerConfirmHidePassword = document.getElementById('rc-hide-password')
const registerConfirmPasswordContainer = document.getElementById('register-confirm-password-field-container')

registerButton.addEventListener('click', function(event){
  event.preventDefault();
  const regexEmail = /^[a-zA-Z0-9"][a-zA-Z0-9"%!+_.-]{0,63}@[a-zA-Z0-9][a-zA-Z0-9.-]+?\.[a-zA-Z]{2,15}$/;
  let errors = 0;
  if(firstName.value == ''){
    let containerField = firstName.parentNode;
    containerField.classList.add('error')
    errors = 1;
  }
  if(lastName.value == ''){
    let containerField = lastName.parentNode;
    containerField.classList.add('error')
    errors = 1;
  }
  if(registerEmail.value == '' || !regexEmail.test(registerEmail.value)){
    let containerField = registerEmail.parentNode;
    containerField.classList.add('error')
    errors = 1;
  }
  if(registerPassword.value == '' || registerPassword.value.length < 12){
    let containerField = registerPassword.parentNode.parentNode;
    containerField.classList.add('error')
    errors = 1
  }
  if(registerConfirmPassword.value == '' || registerConfirmPassword.value != registerPassword.value){
    let containerField = registerConfirmPassword.parentNode.parentNode;
    containerField.classList.add('error')
    errors = 1
  }
  if(errors == 0){
    registerForm.submit()
  }
})

firstName.addEventListener('keyup', function(){
  const containerField = firstName.parentNode;
  containerField.classList.remove('error')
})
lastName.addEventListener('keyup', function(){
  const containerField = lastName.parentNode;
  containerField.classList.remove('error')
})
registerEmail.addEventListener('keyup', function(){
  const containerField = registerEmail.parentNode;
  containerField.classList.remove('error')
})
registerPassword.addEventListener('keyup', function(){
  const containerField = registerPassword.parentNode;
  containerField.classList.remove('error')
})
registerConfirmPassword.addEventListener('keyup', function(){
  const containerField = registerConfirmPassword.parentNode;
  containerField.classList.remove('error')
})

registerShowPassword.addEventListener('click', () => {
  registerPassword.setAttribute('type', 'text');
  registerPasswordContainer.classList.add('show')
})
registerHidePassword.addEventListener('click', () => {
  registerPassword.setAttribute('type', 'password');
  registerPasswordContainer.classList.remove('show')
})

registerConfirmShowPassword.addEventListener('click', () => {
  registerConfirmPassword.setAttribute('type', 'text');
  registerConfirmPasswordContainer.classList.add('show')
})
registerConfirmHidePassword.addEventListener('click', () => {
  registerConfirmPassword.setAttribute('type', 'password');
  registerConfirmPasswordContainer.classList.remove('show')
})
